import { useContext } from "react";
import "./menuOffers.styles.scss";
import { MenuContext } from "../../../../contexts/menu.context";
import MenuOfferItem from "./menuOfferItem/menuOfferItem.component";
const MenuOffers = () => {
  const { menuContext, setMenuContext } = useContext(MenuContext);

  return (
    <div className="menu-offers-container">
      <div className="menu-offers-box">
        {Object.keys(menuContext).map((index) => {
          if (index !== "metadata" && index !== "hotelID") {
            return (
              <MenuOfferItem menuItem={menuContext[index]} itemName={index} />
            );
          }
        })}
      </div>
    </div>
  );
};
export default MenuOffers;
